import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Media from 'react-media';

import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import { TextField, BtnGreenBig } from 'components/common/Elements/Elements';
import { postRequest } from 'utils/requests';

// import { isValid } from './validation';

import LogoText from 'assets/svg/logoPurple.svg';

import classes from './LoginPage.module.scss';

const PasswordReset = ({ history, onOfNotif }) => {
  // const language = useUserState().user.language;
  const language = 'uk';
  const params = useParams();

  const [newpass, setNewpass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [wrongText, setWrongText] = useState({ newpass: '', confirmPass: '' });

  const onSubmit = e => {
    trackingEvent('save_new_pass');
    e.preventDefault();

    if (newpass !== confirmPass && newpass.length <= 16) {
      setWrongText({
        newpass: ' ',
        confirmPass: t('error', 'ERR_DIFFERENT_PASS', language)
      });
      return;
    }

    const url = `/api/accounts/password-reset/${params.idreset}`;

    const REQ_BODY = {
      password: newpass
    };

    postRequest(url, REQ_BODY)
      .then(() => {
        onOfNotif('on', t('notif', 'PASS_CHANGE', language), false, '2000');
        history.push('/login');
      })
      .catch(err => {
        setWrongText({
          newpass: ' ',
          confirmPass: t('error', 'ERR_LINK', language)
        });
      });
  };

  const onNewpass = e => {
    setNewpass(e.target.value);
  };

  const onConfirmPass = e => {
    setConfirmPass(e.target.value);
  };

  const isDisabled = () => {
    return !(newpass && confirmPass);
  };

  const onCancel = () => {
    trackingEvent('cancel_reset_pass');
    history.push('/login');
  };

  return (
    <div className={classes.loginPage}>
      <div className={classes.infoBox}>
        <div className={classes.formWrap}>
          <h1 className={classes.title}>
            <p className={classes.title_top}>
              {t('LoginPage', 'SIGN_IN', language)}
            </p>
            <p className={classes.title_bottom}>
              {t('LoginPage', 'ACCOUNT', language)}
              <img
                src={LogoText}
                className={classes.logo}
                alt="logo"
                width="115"
                height="20"
              />
            </p>
          </h1>

          <form onSubmit={onSubmit} className={classes.loginForm}>
            <div>
              <TextField
                className={
                  wrongText.newpass && wrongText.newpass === ' '
                    ? classes.emailField_errorServer
                    : wrongText.newpass
                    ? classes.emailField_error
                    : classes.emailField
                }
                borderRadius
                value={newpass}
                onChange={onNewpass}
                labelText={t('passwordReset', 'NEW_PASS', language)}
                placeholder={t('passwordReset', 'ENTER_NEW_PASS', language)}
                type="password"
                required
                errorText={wrongText.newpass}
              />
              <TextField
                className={
                  !wrongText.confirmPass
                    ? classes.useremailField
                    : wrongText.confirmPass === t('error', 'ERR_LINK', language)
                    ? classes.useremailField_errorBig
                    : classes.useremailField_error
                }
                borderRadius
                value={confirmPass}
                onChange={onConfirmPass}
                labelText={t('passwordReset', 'CONFIRM_PASS', language)}
                placeholder={t('passwordReset', 'ENTER_NEW_PASS', language)}
                type="password"
                required
                errorText={wrongText.confirmPass}
              />
            </div>
            <BtnGreenBig
              textButton={t('passwordReset', 'SAVE', language)}
              type={'submit'}
              disabled={isDisabled()}
            />
          </form>

          <button
            type="button"
            className={classes.linkForgot}
            onClick={onCancel}
          >
            {t('LoginPage', 'CANCEL_RESET_PASS', language)}
          </button>
        </div>
      </div>
      <Media
        queries={{
          large: '(min-width: 1280px)'
        }}
      >
        {matches => (
          <>{matches.large && <div className={classes.decorBox}></div>}</>
        )}
      </Media>
    </div>
  );
};

PasswordReset.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  onOfNotif: PropTypes.func
};

export default PasswordReset;
